import "../../pages/organization/receipts/nota-fiscal.scss";

import { SearchIcon } from "lucide-react";
import { FunctionComponent, useState } from "react";

import { DataList, DataListColumn, FormField, StatusBadge, MoneyValue } from "../ui";

export enum STATUS_OPTIONS {
    "TODOS"       = "todos",
    "PENDENTE"    = "pendente",
    "APROVADO"    = "aprovado",
    "REJEITADO"   = "rejeitado",
    "PROCESSANDO" = "processando",
}

const ReceiptList: FunctionComponent = () => {

    const [dataInicial, setDataInicial]   = useState("");
    const [dataFinal, setDataFinal]       = useState("");
    const [statusFilter, setStatusFilter] = useState("TODOS");
    const [numeroOrdem, setNumeroOrdem]   = useState("");
    const [document, setDocument]         = useState("");

    const [statusResults] = useState<any[]>([]);

    const handleFilter = () => {
        console.log({ dataInicial, dataFinal, statusFilter, numeroOrdem, document });
    };

    const columns: DataListColumn<any>[] = [
        { key: "numero",       header: "Numero",       render: (n) => n.numero, mono: true },
        { key: "data",         header: "Data",         render: (n) => <span style={{ opacity: .55 }}>{n.data}</span>, mono: true },
        { key: "valor",        header: "Valor",        render: (n) => <MoneyValue amount={n.valor} tone="neutral" />, align: "right" },
        { key: "destinatario", header: "Destinatario", render: (n) => n.destinatario },
        { key: "status",       header: "Status",       render: (n) => <StatusBadge status={n.status} /> },
    ];

    return (
        <div className="tab-status">
            <div className="filters">
                <FormField label="Data Inicial">
                    <input type="date" value={dataInicial} onChange={(e) => setDataInicial(e.target.value)} />
                </FormField>
                <FormField label="Data Final">
                    <input type="date" value={dataFinal} onChange={(e) => setDataFinal(e.target.value)} />
                </FormField>
                <FormField label="Numero da Ordem">
                    <input type="text" placeholder="Ex: 12345"
                        value={numeroOrdem} onChange={(e) => setNumeroOrdem(e.target.value)} />
                </FormField>
                <FormField label="CPF/CNPJ">
                    <input type="text" placeholder="Ex: 11122233344"
                        value={document} onChange={(e) => setDocument(e.target.value)} />
                </FormField>
                <FormField label="Status">
                    <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                        {Object.values(STATUS_OPTIONS).map((s) => (
                            <option key={s} value={s}>{s.toUpperCase()}</option>
                        ))}
                    </select>
                </FormField>
                <button className="btn-pill primary" onClick={handleFilter}>
                    <SearchIcon size={14} /> Filtrar
                </button>
            </div>

            <DataList
                columns={columns}
                rows={statusResults}
                empty="Nenhum resultado encontrado."
            />
        </div>
    );
};

export default ReceiptList;
